import en from './locales/en';
import hi from './locales/hi';
import mr from './locales/mr';

export const LANGUAGE_STORAGE_KEY = 'app_language';
const warnedMissingKeys = new Set();

export const languageCatalog = {
  en: {
    code: 'en',
    label: 'English',
    nativeLabel: 'English',
    messages: en
  },
  hi: {
    code: 'hi',
    label: 'Hindi',
    nativeLabel: 'हिंदी',
    messages: hi
  },
  mr: {
    code: 'mr',
    label: 'Marathi',
    nativeLabel: 'मराठी',
    messages: mr
  }
};

export const interpolateMessage = (template, params = {}) => {
  return Object.entries(params).reduce((message, [key, value]) => {
    return message.replaceAll(`{${key}}`, String(value));
  }, template);
};

export const translateMessage = (language, key, params = {}) => {
  const selectedLanguage = languageCatalog[language] || languageCatalog.en;
  const template = selectedLanguage.messages[key] || languageCatalog.en.messages[key] || key;

  if (!selectedLanguage.messages[key] && language !== 'en') {
    const warningKey = `${language}:${key}`;
    if (!warnedMissingKeys.has(warningKey)) {
      warnedMissingKeys.add(warningKey);
      console.warn(`[i18n] Missing translation for "${key}" in ${language}.`);
    }
  }

  return interpolateMessage(template, params);
};
